// src/constants/fleet.js
export const FLEET_LIST = [
    'Arval',
    'Autoexpert Rohlik',
    'Ayvens',
    'BusinessLease', // externi script
    'Leaseplan Drivalia', // externi script
    'MHC Mobility',
    'SIXT',
    'SkoFIN', // externi script
  ]
  
  export const FILTER_OPTIONS = {
    ALL: 1,
    UPLOADED: 2,
    ARCHIVED: 5,
    DELETED: 6,
    TIRE_CATEGORY: 7
  }
  
  export const ACTION_TYPES = {
    MANUAL_COMPLETE: 'MANUALNE_DOKONCIT',
    ARCHIVE: 'Archivovat',
    DELETE: 'SMAZAT'
  }

  export const FLEET_HIDDEN_COLUMNS = [
    'mywayID', // Číslo zakázky MyWay
    'dealerDocID',  // "Číslo zakazky dealera"
    'shodaCeny',
    'statusNahrani', // Nahráno do MW
    'duvodUkonceni', // "Důvod ukončení nahrání"
    'akce'
  ]
